module.exports = __webpack_public_path__ + "static/media/not_allowed_audio.147e28d7.gif";